import { useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet'

import { Spinner } from '@/components/ui/spinner'
import { getAuthStatus, redeemSignInTicket } from '../../models/auth'
import { createTestUser } from '../../models/user'

export function CreateTestUser() {
  const [error, setError] = useState<string | null>(null)
  const startedRef = useRef(false)

  useEffect(() => {
    if (startedRef.current) return
    startedRef.current = true

    async function run() {
      let signInToken: string
      try {
        // A fresh browser has no CSRF cookie until this, and redeeming the ticket is a checked write.
        await getAuthStatus()
        signInToken = (await createTestUser()).signInToken
      } catch {
        setError('Failed to create test user.')
        return
      }
      try {
        await redeemSignInTicket(signInToken)
      } catch {
        setError('Failed to log in as the new test user.')
        return
      }
      window.location.href = '/application'
    }

    void run()
  }, [])

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-sm text-red-600">{error}</p>
      </div>
    )
  }

  return (
    <>
      <Helmet>
        <title>Creating test user</title>
      </Helmet>
      <div className="flex min-h-screen items-center justify-center gap-2">
        <Spinner className="size-6" />
        <span className="text-sm text-gray-500">Creating test user...</span>
      </div>
    </>
  )
}
